import Api from '../../api';
import { Job } from '../../types/dentist/calendar';

/**
 * Fetch all jobs for the dentist's calendar
 */
export const getAllJobs = async (): Promise<Job[]> => {
  try {
    const response = await Api.getDentistJobs();
    return response || [];
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};

/**
 * Fetch hire jobs count for the "Hire Staff" button badge
 */
export const getHireJobsCount = async (): Promise<number> => {
  try {
    const hireJobs = await Api.getAllHireJobs();
    return hireJobs?.length || 0;
  } catch (error) {
    console.error('Error fetching hire jobs count:', error);
    return 0;
  }
};

/**
 * Fetch unviewed job applications count for the current dentist (for Hire Staff badge)
 */
export const getUnviewedApplicationsCount = async (): Promise<number> => {
  try {
    // Call backend route that returns { result: number }
    const anyApi = Api as any;
    if (typeof anyApi.request === 'function' && typeof anyApi.baseUrl === 'string') {
      const response = await anyApi.get('v3/jobApplications/unviewed');
      const count = (response && (response.result ?? response.count)) || 0;
      return Number(count) || 0;
    }
    return 0;
  } catch (error) {
    console.error('Error fetching unviewed applications count:', error);
    return 0;
  }
};

/**
 * Refresh job data for a specific job
 */
export const refreshJob = async (jobId: number): Promise<Job | null> => {
  try {
    const response = await Api.getJobDetails(jobId);
    return response || null;
  } catch (error) {
    console.error('Error refreshing job:', error);
    return null;
  }
}; 